module.exports = __webpack_public_path__ + "img/injective-7.f8c396cf.webp";